import border from '../../border';

const light = (params) => border.active.light(params);

export default light;
